import React from 'react'

import Heading from '../../../siteBuilder/blocks/core/Heading/Heading'
import { BlockQuote, FlexGrid, Box } from '@telus-uds/components-web'
import { TextRenderer } from '../../../siteBuilder/utils/text/TextRenderer'
import { SIZES } from '../../utils/constants'
import { useWindowSize } from '../../../hooks/useWindowSize'

import { AuthorContainer } from './styles'
import BBImage from '../Image'
import { Asset } from 'contentful'

export type QuoteProps = {
  text: string
  author: string
  image?: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>
  ctaLink?: {
    fields: {
      text: string
      link: string
    }
  }
}

const Quote = ({ text, image, ctaLink, author }: QuoteProps) => {
  const windowSize = useWindowSize()

  // TODO: in phase 3, adjust or remove level prop in contentful
  if (!text) {
    return <React.Fragment />
  }

  return (
    <div data-testid="bb-quote">
      <FlexGrid>
        <div>
          <Box bottom={4}>
            <FlexGrid.Row>
              <FlexGrid.Row>
                <FlexGrid.Col xs={12} md={image && image?.fields ? 6 : 12} xl={image?.fields ? 8 : 12}>
                  <BlockQuote textStyle="heading" link={ctaLink?.fields?.text} linkHref={ctaLink?.fields?.link}>
                    <TextRenderer>{text}</TextRenderer>
                  </BlockQuote>
                </FlexGrid.Col>
                {image && image?.fields && SIZES.md <= windowSize.width && (
                  <FlexGrid.Col xs={12} md={6} xl={4}>
                    <BBImage
                      src={image.fields?.file?.url}
                      width={image.fields?.file?.details?.image?.width}
                      height={image.fields?.file?.details?.image?.height}
                      alt={image.fields?.title}
                      removeWhiteSpace
                      placeholder="blur"
                      blurDataURL={image.fields?.file?.url}
                    />
                  </FlexGrid.Col>
                )}
              </FlexGrid.Row>
            </FlexGrid.Row>
            {author && (
              <AuthorContainer>
                <Heading heading="h4" size="h4" text={`- ${author}`} />
              </AuthorContainer>
            )}
          </Box>
        </div>
      </FlexGrid>
    </div>
  )
}

export default Quote
